import React, { useState } from 'react';
import { Inline, Radio, Stack, Text } from '@treatwell/ui';
import { Brand } from 'js/model/rainbow/venue/Brand';
import { ConditionalWrapper } from 'js/components/Utilities/ConditionalWrapper';
import { ShowMore } from '../ShowMore/ShowMore';
import styles from './BrandFilter.module.css';

type AllBrands = {
  id: AllBrandsId;
  name: string;
};

export type Brands = [AllBrands, ...Brand[]];
export type AllBrandsId = typeof ALL_BRANDS;

export const ALL_BRANDS = 'allBrands';

const MAX_INITIALLY_SHOWN = 6;

export const BrandFilter = ({
  brands,
  selectedBrandIds,
  onChange,
}: {
  brands: Brands;
  selectedBrandIds: (number | AllBrandsId)[];
  onChange: (aggregationId: number | AllBrandsId) => void;
}) => {
  const [showAllBrands, setShowAllBrands] = useState(
    brands.length <= MAX_INITIALLY_SHOWN
  );
  const brandsToShow = brands.slice(
    0,
    showAllBrands ? brands.length : MAX_INITIALLY_SHOWN
  );

  function handleBrandClick(brand: AllBrands | Brand): void {
    onChange(brand.id);
  }

  return (
    <ConditionalWrapper
      condition={!showAllBrands}
      render={(children) => (
        <Stack align="start" space="sm">
          {children}
        </Stack>
      )}
    >
      <Stack className={styles.list} as="ul" space="sm">
        {brandsToShow.map((brand) => (
          <li key={brand.name}>
            <Inline justify="between" space="sm">
              <Text
                className={styles.label}
                type="caption"
                as="label"
                htmlFor={brand.name}
              >
                {brand.name}
              </Text>
              <Radio
                id={brand.name}
                name={brand.name}
                value={String(brand.id)}
                onChange={() => handleBrandClick(brand)}
                checked={selectedBrandIds.includes(brand.id)}
              />
            </Inline>
          </li>
        ))}
      </Stack>

      {!showAllBrands && (
        <ShowMore
          onClick={() => {
            setShowAllBrands(true);
          }}
        />
      )}
    </ConditionalWrapper>
  );
};
